var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.notMatchingReasons?.length)?_c(_setup.MarvinInfoBox,{attrs:{"text":_setup.t('recommendations.notMatchingReasonsText', {
    list: _setup.list
  }).toString(),"mood":"concerned"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }